import baseURL from './baseURL';

/**
 * Get the full URL for a file or profile image.
 * If the URL is already absolute (starts with http or https), return it.
 * Otherwise, prepend the server host (baseURL without /api).
 */
export const getFileURL = (url) => {
    if (!url) return '';

    // If it's already a full URL, blob URL, or data URL, return it as is
    if (
        url.startsWith('http://') ||
        url.startsWith('https://') ||
        url.startsWith('blob:') ||
        url.startsWith('data:')
    ) {
        return url;
    }

    // Get server host by removing /api from the end of baseURL
    // baseURL typically looks like "http://domain.com/api"
    const serverHost = (baseURL || '');

    // Ensure the relative path starts with a slash
    const sanitizedPath = url.startsWith('/') ? url : `/${url}`;

    return `${serverHost}${sanitizedPath}`;
};

export default getFileURL;
